<kl-form-container
  [title]="title | translate"
  [mode]="'mode'"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow || errorShow"
  [alertType]="alertType"
  [saveAndNew]="false"
  [buttons]="buttons"
  (onCloseAlert)="alertShow = false; errorShow = false"
>
  <form #userForm="ngForm" novalidate>
    <div class="col-md-12 col-sm-12 mt-2">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="form-group row">
            <label for="user_username" class="col-md-4 col-sm-6">
              <small
                >{{ "service_key" | translate }}
                <i class="text-danger">*</i></small
              >
            </label>
            <div class="col-md-8 col-sm-6">
              <input
                [disabled]="isReadOnly"
                #focusElement
                id="user_username"
                name="user_username"
                class="form-control form-control-sm"
                required
                maxLength="6"
                klNumberInput
                #service_key="ngModel"
                [ngClass]="errorShow && service_key.invalid ? 'errorInput' : ''"
                [(ngModel)]="entity.service_key"
              />
              <div
                *ngIf="errorShow && service_key.invalid"
                class="errorMessage"
              >
                {{ "important_area" | translate }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="password" class="col-md-4 col-sm-6">
              <small
                >{{ "password" | translate }}
                <i class="text-danger">*</i></small
              >
            </label>
            <div class="col-md-8 col-sm-6">
              <input
                [disabled]="true"
                id="password"
                name="password"
                class="form-control form-control-sm"
                [(ngModel)]="entity.password"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-form-container>
